/*
 * Confidential and Proprietary.
 * Do not distribute without 1-800-Flowers.com, Inc. consent.
 * Copyright 1-800-Flowers.com, Inc. 2019. All rights reserved.
 */

import React, { useEffect, useRef, useState } from 'react';
import {
    array, bool, func, string,
} from 'prop-types';
import { makeStyles, useMediaQuery } from '@material-ui/core';

import { EXTERNAL_TAB_KEYS, sendStatusToExternalTab } from '../utils/multipleTabsChat';

const useStyles = makeStyles((theme) => ({
    continueModal: {
        position: 'absolute',
        top: '100px',
        left: 'calc(50% - 150px)',
        width: '300px',
        zIndex: 9999,
        boxShadow: '0 2px 1px -1px rgba(0,0,0,.2), 0 1px 1px 0 rgba(0,0,0,.14), 0 1px 3px 0 rgba(0,0,0,.12)',
        backgroundColor: '#fff',
        borderRadius: '2px',
    },
    mediaModalDialog: {
        maxWidth: '100%',
        margin: '0 auto',
        border: '1px solid rgba(0,0,0,.2)',
        borderRadius: '2px',
    },
    continueModalDialog: {
        maxWidth: '100%',
        margin: '0 auto',
        border: '1px solid rgba(0,0,0,.2)',
    },
    continueModalBody: {
        height: '400px',
        overflow: 'auto',
        textAlign: 'center',
    },
    continueBtn: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        alignSelf: 'center',
        padding: '.5rem .75rem',
        fontSize: '1rem',
        color: '#fff',
        '&:hover': {
            color: '#fff',
        },
        backgroundColor: `${theme.palette.cms?.primary || theme.palette.colorPrimary}`,
        border: `2px solid ${theme.palette.cms?.primary || theme.palette.colorPrimary}`,
        borderRadius: '.25rem',
        width: '49%',
    },
    timerCloseBtn: {
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        alignSelf: 'center',
        padding: '.5rem .75rem',
        fontSize: '1rem',
        color: `${theme.palette.cms?.primary || theme.palette.colorPrimary}`,
        '&:hover': {
            color: `${theme.palette.cms?.primary || theme.palette.colorPrimary}`,
        },
        backgroundColor: '#FFF',
        border: `2px solid ${theme.palette.cms?.primary || theme.palette.colorPrimary}`,
        borderRadius: '.25rem',
        width: '49%',
    },
    continueBtnOutline: {
        backgroundColor: '#fff',
        color: `${theme.palette.cms?.primary || theme.palette.colorPrimary}`,
        border: `2px solid ${theme.palette.cms?.primary || theme.palette.colorPrimary}`,
    },
    confirmModalBody: {
        padding: '15px 15px 0px',
        textAlign: 'center',
    },
    confirmModalFooter: {
        padding: '15px',
        textAlign: 'center',
        display: 'flex',
        justifyContent: 'center',
        gap: '10px',
    },
    greyOutBackground: {
        backgroundColor: 'rgba(0,0,0,0.5)',
        width: '100%',
        height: '100%',
        position: 'absolute',
        zIndex: 2,
        borderRadius: '5px 5px 0 0',
    },
}));
const showpopuptime = 300;
const timeout = 600;
const TimerDialog = ({
    startTimer,
    closeChatAndCleanUpSession,
    messages,
    showTimer,
    setShowTimer,
    onCloseDialog,
    setCloseChatConfirm,
    setShowReconnectButton,
    minimizeChatWidget,
    handleSendSurveyLink,
    convId,
    mainTabConvID,
    dummyTabId,
    featureFlags,
    setIsChatInputDisabled,
}) => {
    // state management
    const [responsiveModalDialogClass, setResponsiveModalDialogClass] = useState(undefined);
    const matches = useMediaQuery('(min-width: 576px)');
    const classes = useStyles();
    const [seconds, setSeconds] = useState(dummyTabId || !convId ? showpopuptime : timeout);
    const [timeLeft, setTimeLeft] = useState(dummyTabId || !convId ? showpopuptime : timeout);
    const timerInterval = useRef();

    const countDown = (sec) => {
        if (timeLeft > 0) {
            setTimeLeft(sec - 1);
        }
        // if popup time has elapsed, show dialog
        if (sec === timeout - showpopuptime) {
            setShowTimer(true);
            setIsChatInputDisabled(true);
            minimizeChatWidget(false);
            if (onCloseDialog) {
                setCloseChatConfirm(false);
            }
            if (convId) sendStatusToExternalTab(EXTERNAL_TAB_KEYS.ON_SHOW_TIMER, convId, true, '', '', featureFlags);
        }

        // if timer has run out, clean session and show reconnect button
        if (sec === 0) {
            handleSendSurveyLink();
            clearInterval(timerInterval.current);
            setShowTimer(false);
            closeChatAndCleanUpSession();
            setShowReconnectButton(true);
            if (convId) sendStatusToExternalTab(EXTERNAL_TAB_KEYS.ON_TIMER_DIALOG, convId, true, '', '', featureFlags);
        }
    };

    /**
     * Formats the remaining time before the chat closes for inactivity
     * to the format mm:ss
     * @param {number} s
     */
    const fmtMSS = (s) => {
        const second = s % 60;
        const minutes = (s - second) / 60;
        return minutes + (second > 9 ? ':' : ':0') + second;
    };

    const resumeTimer = () => {
        setShowTimer(false);
        setIsChatInputDisabled(false);
        if (convId) setSeconds(timeout);
        sendStatusToExternalTab(EXTERNAL_TAB_KEYS.ON_RESUME_TIMER, convId || mainTabConvID, !!convId, dummyTabId, '', featureFlags);
    };

    useEffect(() => {
        // Clear interval and reset timer if startTimer or message changes
        clearInterval(timerInterval.current);
        setSeconds(timeout);
        setTimeLeft(timeout);

        // run interval
        if (startTimer && seconds > 0) {
            let intervalSeconds = seconds;
            timerInterval.current = setInterval(() => {
                setSeconds((prevSec) => {
                    intervalSeconds = prevSec - 1;
                    return prevSec - 1;
                });
                countDown(intervalSeconds);
            }, 1000);
        }

        if (!startTimer && !showTimer) {
            if (timerInterval?.current) {
                clearInterval(timerInterval.current);
            }
        }

        return () => clearInterval(timerInterval.current);
    }, [startTimer, messages]);

    useEffect(() => {
        if (matches) {
            setResponsiveModalDialogClass(classes.mediaModalDialog);
        } else {
            setResponsiveModalDialogClass(classes.continueModalDialog);
        }
    }, [matches]);

    return (showTimer
        ? (
            <div className={classes.greyOutBackground}>
                <div id="continue-modal" className={`${classes.continueModal}`} data-testid="timer-dialog">
                    <div className={responsiveModalDialogClass}>
                        <div className={classes.confirmModalContent}>
                            <div className={classes.confirmModalBody} data-testid="timer-dialog-message">
                                This chat will close in  <span id="timerdiv">{fmtMSS(timeLeft)}</span>  minutes.
                            </div>
                            <div className={classes.confirmModalFooter}>
                                <button
                                    type="button"
                                    onClick={resumeTimer}
                                    className={classes.continueBtn}
                                    id="continue-chat"
                                    data-testid="continue-btn"
                                >Resume Chat
                                </button>
                                <button
                                    type="button"
                                    onClick={() => {
                                        closeChatAndCleanUpSession();
                                        sendStatusToExternalTab(EXTERNAL_TAB_KEYS.ON_CLOSE_DIALOG, convId || mainTabConvID, !!convId, dummyTabId, '', featureFlags);
                                    }}
                                    className={classes.timerCloseBtn}
                                    id="continue-chat"
                                    data-testid="timer-close-btn"
                                >Close Chat
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        )
        : null);
};

TimerDialog.propTypes = {
    startTimer: bool.isRequired,
    closeChatAndCleanUpSession: func.isRequired,
    messages: array.isRequired,
    onCloseDialog: func.isRequired,
    setCloseChatConfirm: func.isRequired,
    showTimer: bool.isRequired,
    setShowTimer: func.isRequired,
    setShowReconnectButton: func.isRequired,
    minimizeChatWidget: func.isRequired,
    handleSendSurveyLink: func.isRequired,
    setIsChatInputDisabled: func.isRequired,
    convId: string,
    mainTabConvID: string,
    dummyTabId: string,
    featureFlags: array,
};

TimerDialog.defaultProps = {
    convId: '',
    mainTabConvID: '',
    dummyTabId: '',
    featureFlags: [],
};

export default TimerDialog;
